import { ReactNode, useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Loader2 } from 'lucide-react';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

interface PaymentProviderProps {
  children: ReactNode;
  amount: number;
}

export function PaymentProvider({ children, amount }: PaymentProviderProps) {
  const [clientSecret, setClientSecret] = useState<string | null>(null);

  useEffect(() => {
    fetch('https://payment-gateway.qubit-home.workers.dev', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount }),
    })
      .then(res => res.json())
      .then(data => setClientSecret(data.client_secret))
      .catch(err => console.error(err));
  }, [amount]);

  if (!clientSecret) {
    return <div className="flex items-center justify-center h-64"><Loader2 className="animate-spin" /></div>;
  }
  
  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      {children}
    </Elements>
  );
}